import { render, staticRenderFns } from "./license-template.vue?vue&type=template&id=0fa423c0&scoped=true"
import script from "./license-template.vue?vue&type=script&lang=js"
export * from "./license-template.vue?vue&type=script&lang=js"
import style0 from "./license-template.vue?vue&type=style&index=0&id=0fa423c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa423c0",
  null
  
)

export default component.exports